import React from "react";
import { useSettings } from "../contexts/SettingsContext";

const TITLES = { terms: "Termeni și Condiții", gdpr: "Politica GDPR", return: "Politică de retur" };
const KEYS = { terms: "terms_content", gdpr: "gdpr_content", return: "return_policy_content" };

export default function StaticPage({ type }) {
    const { settings } = useSettings();
    const content = settings[KEYS[type]] || "";
    return (
        <div className="container-x py-10 max-w-3xl" data-testid={`static-${type}`}>
            <div className="overline mb-2">Informații legale</div>
            <h1 className="font-heading text-4xl uppercase mb-6">{TITLES[type]}</h1>
            <div className="prose prose-neutral max-w-none whitespace-pre-line text-muted-foreground leading-relaxed">
                {content}
            </div>
        </div>
    );
}
